import { render, staticRenderFns } from "./PersonContact.vue?vue&type=template&id=74d87abe"
import script from "./PersonContact.vue?vue&type=script&lang=js"
export * from "./PersonContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports